import { render, staticRenderFns } from "./Smiles.vue?vue&type=template&id=069c5c1c&scoped=true"
import script from "./Smiles.vue?vue&type=script&lang=ts"
export * from "./Smiles.vue?vue&type=script&lang=ts"
import style0 from "./Smiles.vue?vue&type=style&index=0&id=069c5c1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c5c1c",
  null
  
)

export default component.exports